import { ILandingPageData } from "@/interfaces/ILandingPage";
import styles from "./WhyChooseUs.module.css";
import Image from "next/image";

type props = {
    data: ILandingPageData['whyChooseUs']
}
export function WhyChooseUs({ data }: props) {
    return (
        <section className="section">
            <div className="container1350">
                <h3 className="font26 text222 textCenter mb20 fontSM20 mbSM15">{data.headingText}</h3>
                {/* <span className="font20 text666 dispBlok textCenter fontSM14">With us, you experience the power of ideas, design and craftsmanship come alive.</span> */}
                <div className={styles.whychoInermain}>
                    <div className={styles.whyChoeinleft}>
                        {
                            data.data.slice(0, 4).map((item, index) => {
                                return (
                                    <div className={`${styles.whyChoeslefttiles} ${styles.bdRightno} ${styles.bdBottomno}`} key={index}>
                                        <Image width={60} height={60} className="img-responsive mb16" src={"/assets/images/" + item.image} alt="" />
                                        <span className="font16 text000 dispBlok fontSM12">{item.text}</span>
                                        <p className="font16 text000 dispBlok fontSM12">{item.subText}</p>
                                    </div>
                                )

                            }
                            )
                        }
                    </div>
                    <div className={styles.whyChoesright}>
                        <Image width={60} height={60} className="img-responsive mb16" src={"/assets/images/" + data.data[4].image} alt="" />
                        <span className="font16 text000 dispBlok fontSM12">{data.data[4].text}</span>
                        <p className="font16 text000 dispBlok fontSM12">{data.data[4].subText}</p>
                    </div>
                </div>
                <div className={styles.bokkConsbtbox}>
                    <button className="btnPrimery" id="openExitIntentForm">
                        {data.leadBtnText}
                    </button>
                </div>
            </div>
        </section>
    )
}